exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hamburger[data-v-4e9c855b] {\r\n\tdisplay: inline-block;\r\n\tcursor: pointer;\r\n\twidth: 15px;\r\n\theight: 15px;\r\n\ttransform: rotate(0deg);\r\n\ttransition: .38s;\r\n\ttransform-origin: 50% 50%;\r\n\tposition: relative;\r\n    top: -2px;\n}\n.hamburger.is-active[data-v-4e9c855b] {\r\n\ttransform: rotate(90deg);\n}\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e9c855b","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Hamburger/index.vue
// module id = 255
// module chunks = 99